
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { datavUrl } from '@/api/home';

@Component({
  name: 'StatisticsStaff',
  components: {

  }
})
export default class extends Vue {
  private formSearch:any = {
    // startTime: '',
    // endTime: '',
    timePeriods: [],
    timeout: '5'
  }
  private iframeHeight= window.innerHeight - 65;
  private url=''
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, start]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

  created() {
    let data = new Date();
    let startTime = new Date(data.getFullYear() + '/01/01').getTime();
    let endTime = data.getTime();
    // this.formSearch.startTime = startTime;
    // this.formSearch.endTime = endTime;
    this.formSearch.timePeriods = [startTime, endTime]
    this.datavUrl();
  }
  private datavUrl() {
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    let vipLevel = UserModule.getCompany.vip_level;
    pamars.type = vipLevel.substr(0, 1) === '2' ? '1' : '2';
    pamars.start_time = this.formSearch.timePeriods ? this.formSearch.timePeriods[0] / 1000 : '';
    pamars.end_time = this.formSearch.timePeriods ? this.formSearch.timePeriods[1] / 1000 : '';
    pamars.timeout = this.formSearch.timeout;
    datavUrl(pamars).then(res => {
      if (res.data) {
        this.url = res.data.order_url;
      }
    });
  }

  handleSearch() {
    this.datavUrl();
  }

  handleClear() {
    let data = new Date();
    let startTime = new Date(data.getFullYear() + '/01/01').getTime();
    let endTime = data.getTime();
    // this.formSearch.startTime = startTime;
    // this.formSearch.endTime = endTime;
    this.formSearch.timePeriods = [startTime, endTime]
    this.formSearch.timeout = 5;
    this.datavUrl();
  }

  private fullScreen() {
    this.requestFullScreen(document.getElementById('mainContent'));
  }

  requestFullScreen(element: any) {
    let requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
    if (requestMethod) {
      requestMethod.call(element);
    } else if (typeof window.ActiveXObject !== 'undefined') {
      let wscript = new ActiveXObject('WScript.Shell');
      if (wscript !== null) {
        wscript.SendKeys('{F11}');
      }
    }
  }
}
